<template>
    <div>
        <div>
            <md-empty-state
                    class="md-primary"
                    md-icon="perm_phone_msg"
                    md-label="Add a Telephone Number"
                    md-description="Let potential lenders contact you"
            >
                <b-field expanded>
                    <b-input maxlength="11" :has-counter="false" size="is-medium" v-model="tel"></b-input>
                </b-field>
                <md-button v-if="tel.length === 11 && isLoading === false" @click="addTel" class="md-primary md-raised">Continue</md-button>
                <md-progress-spinner v-if="isLoading === true" md-mode="indeterminate"></md-progress-spinner>
            </md-empty-state>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AddTel",
        data() {
            return {
                tel: '09',
                isLoading: false
            }
        },
        methods: {
            addTel() {
                const vm = this;
                vm.isLoading = true;
                let url = `${vm.$host}/users/${localStorage.user}?access_token=${localStorage.token}`;
                vm.axios.patch(url, {tel: vm.tel})
                    .then(function (res) {
                        let to = vm.$route.query.to;
                        if(res.data.verified) {
                            if (to) {
                                vm.$router.push({name: to})
                            } else {
                                vm.$router.push({name: 'home'})
                            }
                        } else {
                            if (to) {
                                vm.$router.push({name: 'getVerified', query: { to: to }})
                            } else {
                                vm.$router.push({name: 'getVerified'})
                            }
                        }
                    }).catch(function (e) {
                        alert(e)
                    })
            }
        }
    }
</script>

<style scoped>

</style>